import { memo, ReactElement } from 'react';

import { useCart } from '~/lib/cart';
import { UserObjectProps } from '~/types/user';
import { CartItemProps, CartCouponProps } from '~/types/cart';
import { DealItem } from '~/components/cart';

export const DealItemList = ({
  cartItems,
  user,
  hasPlusInCart,
  couponData,
}: {
  cartItems: CartItemProps[];
  user?: UserObjectProps;
  hasPlusInCart: boolean;
  couponData?: CartCouponProps;
}): ReactElement => {
  const { lineItemUpdate } = useCart(undefined, true);
  return (
    <>
      {cartItems.map((item) => (
        <div
          key={item.deal.id}
          className="mt-4 border-b border-sundog pb-4 last:border-0 last:pb-0"
        >
          <DealItem
            item={item}
            hasPlus={user?.has_plus ?? hasPlusInCart}
            couponData={couponData}
            lineItemUpdate={lineItemUpdate}
          />
        </div>
      ))}
    </>
  );
};

export default memo(DealItemList);
